<template>
    <div>
        <h1>Leistung</h1>
        <v-container v-if="!loading">
                <v-row>
                    <v-col cols="12" sm="6" md="12">
                        <v-text-field readonly :value="service.account.firstname + ' ' + service.account.lastname" label="Leistungserbringer"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <v-text-field :value="serviceTypes[service.serviceTypeId]" label="Leistungstyp" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="12">
                        <v-textarea v-model="service.description" label="Beschreibung" rows="1" auto-grow readonly></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                                :value="new Date(service.startDate.substr(0, 10)).toLocaleDateString('ch-DE')"
                                label="Startdatum"
                                prepend-icon="event"
                                readonly
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                                :value="new Date(service.endDate.substr(0, 10)).toLocaleDateString('ch-DE')"
                                label="Enddatum"
                                prepend-icon="event"
                                readonly
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model.number="service.shortActivityCount" label="Tätigkeit Kurz Kat-I" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model.number="service.shortActivityVolunteerCount" label="Anzahl Freiwillige (Kat-I)" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model.number="service.halfDayActivityCount" label="Tätigkeit Halbtag Kat-II" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model.number="service.halfDayActivityVolunteerCount" label="Anzahl Freiwillige (Kat-II)" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model.number="service.fullDayActivityCount" label="Tätigkeit Ganztag Kat-III" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model.number="service.fullDayActivityVolunteerCount" label="Anzahl Freiwillige (Kat-III)" readonly></v-text-field>
                    </v-col>

                </v-row>
        </v-container>
    </div>
</template>

<script>
    import {serviceService} from "../services/serviceService";

    export default {
        name: "Service",
        data() {
            return {
                service: {},
                serviceTypes: {},
                loading: true,
            }
        },
        created() {
            let self = this;
            serviceService.getServiceById(this.$route.params.id).then((service) => {
                self.service = service;
                self.loading = false;
            }).catch((error)=> {
                console.log(error);
            });
            serviceService.getServiceTypes().then((serviceTypes) => {
                for (var i = 0; i < serviceTypes.length; i++) {
                    self.serviceTypes[serviceTypes[i].id] = serviceTypes[i].name;
                }
            }).catch((error) => {
                console.log(error);
            });
         document.title = "Leistung Detail";
        }
    }
</script>

<style scoped>

</style>